import { authFetch } from './auth';

const BASE = '/api';

const json = r => r.json();

export const getParts          = ()  => authFetch(`${BASE}/parts`).then(json);
export const getSections       = id  => authFetch(`${BASE}/parts/${id}/sections`).then(json);
export const getParagraphs     = id  => authFetch(`${BASE}/sections/${id}/paragraphs`).then(json);
export const getPartParagraphs = id  => authFetch(`${BASE}/parts/${id}/paragraphs`).then(json);
export const getDetail        = id  => authFetch(`${BASE}/paragraphs/${id}/detail`).then(json);
export const getParagraphById = id  => fetch(`${BASE}/paragraphs/${id}`).then(json);
export const search        = q   => authFetch(`${BASE}/search?q=${encodeURIComponent(q)}`).then(json);

export const getReviews = () => authFetch(`${BASE}/reviews`).then(json);

export const saveReview = (factId, comment, impact, type) =>
  authFetch(`${BASE}/facts/${factId}/review`, {
    method:  'PUT',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify({ comment, impact: impact || null, type: type || null }),
  }).then(json);

export const saveClauseReview = (clauseId, comment, impact, type) =>
  authFetch(`${BASE}/clauses/${clauseId}/review`, {
    method:  'PUT',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify({ comment, impact: impact || null, type: type || null }),
  }).then(json);

const put  = (url, data) => authFetch(url, { method: 'PUT',  headers: {'Content-Type':'application/json'}, body: JSON.stringify(data) }).then(json);
const post = (url, data) => authFetch(url, { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(data) }).then(json);

export const adminUpdateClause   = (id, data) => put(`${BASE}/admin/clauses/${id}`, data);
export const adminCreateClause   = (data)      => post(`${BASE}/admin/clauses`, data);
export const adminUpdateFact     = (id, data)  => put(`${BASE}/admin/facts/${id}`, data);
export const adminCreateFact     = (data)      => post(`${BASE}/admin/facts`, data);
export const adminUpdateParagraph = (id, data) => put(`${BASE}/admin/paragraphs/${id}`, data);
export const adminUpdateSection  = (id, data)  => put(`${BASE}/admin/sections/${id}`, data);

export const getAbout       = ()        => fetch(`${BASE}/about`).then(json);

export const getAnalysis    = ()        => fetch(`${BASE}/analysis`).then(json);
export const saveAnalysis   = (content) =>
  authFetch(`${BASE}/analysis`, {
    method:  'PUT',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify({ content }),
  }).then(json);

export const getExecSummary  = ()        => fetch(`${BASE}/exec-summary`).then(json);
export const saveExecSummary = (content) =>
  authFetch(`${BASE}/exec-summary`, {
    method:  'PUT',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify({ content }),
  }).then(json);

export const getPrinciples    = ()        => fetch(`${BASE}/principles`).then(json);
export const createPrinciple  = (data)    => authFetch(`${BASE}/principles`, { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(data) }).then(json);
export const updatePrinciple  = (id, data) => authFetch(`${BASE}/principles/${id}`, { method: 'PUT', headers: {'Content-Type':'application/json'}, body: JSON.stringify(data) }).then(json);
export const deletePrinciple  = (id)      => authFetch(`${BASE}/principles/${id}`, { method: 'DELETE' }).then(json);
export const acceptReview       = (factId)   => authFetch(`${BASE}/facts/${factId}/review/accept`,   { method: 'POST' }).then(json);
export const acceptClauseReview = (clauseId) => authFetch(`${BASE}/clauses/${clauseId}/review/accept`, { method: 'POST' }).then(json);

export const postContact        = (data)     => fetch(`${BASE}/contact`, { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(data) }).then(json);
export const getMessages        = ()         => authFetch(`${BASE}/admin/messages`).then(json);
export const getUnreadCount     = ()         => authFetch(`${BASE}/admin/messages/unread-count`).then(json);
export const markMessageRead    = (id, read) => authFetch(`${BASE}/admin/messages/${id}/read`, { method: 'PUT', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ read }) }).then(json);

export const getTags     = ()                  => fetch(`${BASE}/tags`).then(json);
export const createTag   = (data)              => authFetch(`${BASE}/tags`, { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(data) }).then(json);
export const updateTag   = (id, data)          => authFetch(`${BASE}/tags/${id}`, { method: 'PUT', headers: {'Content-Type':'application/json'}, body: JSON.stringify(data) }).then(json);
export const deleteTag   = (id)                => authFetch(`${BASE}/tags/${id}`, { method: 'DELETE' }).then(json);
export const getItemTags = ()                  => fetch(`${BASE}/item-tags`).then(json);
export const setItemTags = (type, id, tagIds)  => authFetch(`${BASE}/item-tags/${type}/${id}`, { method: 'PUT', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ tagIds }) }).then(json);
